import {
  CustomQueryBuilder,
  type GetCheckoutCouponsByCouponCodeResponse,
  useSessionToken,
} from "@birdwatch/client";
import { useMutation } from "@tanstack/react-query";

export type CouponDetailType = GetCheckoutCouponsByCouponCodeResponse;

/**
 * Validates a coupon on demand. Modelled as a mutation rather than a query
 * because it fires from a button press, not from render.
 */
export const useCheckDiscountCode = () => {
  const getToken = useSessionToken();

  return useMutation({
    mutationKey: ["check-discount-code"],
    mutationFn: async ({ couponCode }: { couponCode: string }) => {
      const builder = new CustomQueryBuilder<CouponDetailType>(
        "checkout",
        "/coupons/:couponCode",
        { couponCode },
      );
      const token = await getToken();
      const result = await builder.fetch(token);
      return result.data;
    },
  });
};
